import React, { useState, useEffect } from "react";
import {setAspekForAssessment,setAspekEdit,unsetAspekEdit} from "../actions"
import { connect } from "react-redux";
import { doGet,doDelete } from "../services/api-service";
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/core/styles";
import { withRouter } from "react-router";
import IconButton from "@material-ui/core/IconButton";
import Button from "@material-ui/core/Button";
import Delete from "@material-ui/icons/Delete";
import DeleteForever from "@material-ui/icons/DeleteForever";
import AddIcon from "@material-ui/icons/Add";
import EditIcon from "@material-ui/icons/Edit";
import Select from "react-select";
import DoneIcon from "@material-ui/icons/Done";
import InputIcon from "@material-ui/icons/Input";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Grid from "@material-ui/core/Grid";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import ActionButton from "../components/ActionButton";
import TableFooter  from "@material-ui/core/TableFooter";
import TablePagination   from "@material-ui/core/TablePagination";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Search from "@material-ui/icons/Search";


const PaAspekComponent = (props) => {

    const { classes } = props;

    const [dataTable, setDataTable] = useState([])
    const [rowsPerPage, setRowsPerPage] = useState(10)
    const [page, setPage] = useState(1)
    const [totalRows, setTotalRows] = useState(0)
    const [tobeDelete, setTobeDelete] = useState(0)

    const [statusOptions, setStatusOptions] = useState([
            { value: 1, label: 'Active' },
            { value: 0, label: 'Inactive' }
        ])
        const [selectedStatus, setSelectedStatus] = useState({ value: 1, label: 'Aktif' })

         const [filterParams, setFilterParams] = useState({})

    const statusOnChange = (e) =>{
        setSelectedStatus(e)
    }


    const filter = async () => {
        const params = {
            status : selectedStatus!==null ? selectedStatus.value : null
        };

        setFilterParams(params)
    };


    useEffect(() => {
        props.unsetAspekEdit()
    }, [])

    useEffect(() => {
        if(props.user){
            getData(page)
        }
    }, [filterParams])

    useEffect(() => {
        if(props.user){
            getData(page)
        }
    }, [props.user])

    useEffect(() => {
        getData(page)
    }, [rowsPerPage])

    const getData = async (toPage = 1) => {


        let params={
            page:toPage,
            status:filterParams?.status,
            rowsPerPage:rowsPerPage
        }

        if(props.user.role!=="adm")
        params = {...params, user_id:props.user.emp_id}

        console.log("filterParams", filterParams)

        const response = await doGet("pa/aspek",params)
        if(response && response.data){
            setDataTable(response.data.data)
            setPage(response.data.meta.current_page)
            setTotalRows(response.data.meta.total)
        }
        
    }

    const goToAssessment = (aspek)=>{
        props.setAspekForAssessment(aspek)
        props.history.push("/pa/app/aspek/assessment")
    }

    const edit = (aspek)=>{
        props.setAspekEdit(aspek)
        props.history.push("/pa/app/aspek/create")
    }

    const confirmDelete = (data_id)=>{
        setTobeDelete(data_id)
    }

    const deleteData = async(data_id)=>{
        const params={id:data_id}
        setDataTable(dataTable.filter(data=>data.id!==data_id))
        await doDelete("pa/aspek",params)
        setTobeDelete(0)
        getData(page)
    }

    const changePage=(event, newPage)=>{
        setPage(newPage+1)
        getData(newPage+1)
    }

    const changeRowsPerPage = (event)=> {
        setRowsPerPage(+event.target.value);
        setPage(1);
    }



    return (
        <React.Fragment>
            <Grid
                container
                spacing={8}
                direction="column"
                className={classes.container}
            >
                <Grid container direction="row" alignContent="flex-start">
                    <Grid item xs={10}>
                        <Typography
                            variant="h6"
                            gutterBottom
                            className="animated slideInLeft"
                        >
                            PA Aspek
                        </Typography>
                    </Grid>

                    <Grid item xs={2} align="right">
                        <ActionButton
                            type="fab"
                            for={["adm"]}
                            role={props.user.role}
                            action={() =>
                                props.history.push("/pa/app/aspek/create")
                            }
                            icon={<AddIcon />}
                            color="secondary"
                            class={classes.fab}
                        />

                    </Grid>

                    <Grid container spacing={8} className={classes.filterContainer} >
                        <Grid item spacing={8} xs={9}container>
                            

                            <Grid item xs={4}>
                                <Select
                                    options={statusOptions}
                                    value={selectedStatus}
                                    onChange={statusOnChange}
                                    placeholder="Select Status"
                                    isClearable
                                />
                            </Grid>


                        </Grid>


                        <Grid item xs={2} container justify="flex-end" alignItems="baseline">
                            <IconButton  onClick={filter} color="primary" aria-label="search">
                                <Search />
                            </IconButton>

                        </Grid>
                    </Grid>


                    <Grid item xs={12} className={classes.tableWrapper}>
                        <div className={classes.table}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell align="center">
                                            Code
                                        </TableCell>
                                        <TableCell align="center">
                                            Name
                                        </TableCell>
                                        <TableCell align="center">
                                            Note
                                        </TableCell>
                                        <TableCell align="center">
                                            Creator
                                        </TableCell>
                                        <TableCell align="center">
                                            Status
                                        </TableCell>
                                        <TableCell align="center">

                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {dataTable.length > 0 && dataTable.map(
                                        row => (
                                            <TableRow key={row.id}>
                                                <TableCell align="center">
                                                    {row.code}
                                                </TableCell>
                                                <TableCell align="center">
                                                {row.name}
                                                </TableCell>
                                                <TableCell align="center">
                                                {row.note}
                                                </TableCell>
                                                <TableCell align="center">
                                                {row.created_by_name}
                                                </TableCell>
                                                <TableCell align="center" >
                                                {row.status_value}
                                                </TableCell>
                                                <TableCell align="left" style={{width:250}}>
                                                <ActionButton
                                                    title="enter"
                                                    type="icon-button"
                                                    for={["ldr"]}
                                                    role={props.user.role}
                                                    action={() =>goToAssessment(row)}
                                                    disabled={row.status === 0 || row.is_custom==0}
                                                    icon={<InputIcon fontSize="small" />}
                                                />
                                                <ActionButton
                                                    title="edit"
                                                    type="icon-button"
                                                    for={["adm"]}
                                                    role={props.user.role}
                                                    action={()=>edit(row)}
                                                    icon={<EditIcon fontSize="small"/>}/>

                                                    {tobeDelete!==row.id &&
                                                        <ActionButton
                                                            title="delete"
                                                            type="icon-button"
                                                            for={["adm"]}
                                                            role={props.user.role}
                                                            action={()=>confirmDelete(row.id)}
                                                            icon={<Delete />}
                                                        />
                                                    }
                                                    {tobeDelete===row.id &&
                                                        <>are you sure ?
                                                        <ClickAwayListener onClickAway={()=>setTobeDelete(0)}>
                                                                <ActionButton
                                                                    title="click again to delete"
                                                                    type="icon-button"
                                                                    for={["adm"]}
                                                                    role={props.user.role}
                                                                    action={()=>deleteData(row.id)}
                                                                    icon={<DeleteForever />}
                                                                />
                                                        </ClickAwayListener>
                                                        </>
                                                    }
                                                </TableCell>

                                            </TableRow>

                                        )
                                    )
                                    }


                                </TableBody>
                                <TableFooter>
                                    <tr>
                                        <td colspan="5">
                                            <Grid container justify="flex-end">
                                                <Grid item>
                                                <TablePagination
                                                    rowsPerPageOptions={[5, 10, 25]}
                                                    component="div"
                                                    count={totalRows}
                                                    rowsPerPage={rowsPerPage}
                                                    page={page-1}
                                                    backIconButtonProps={{
                                                        "aria-label": "previous page",
                                                    }}
                                                    nextIconButtonProps={{
                                                        "aria-label": "next page",
                                                    }}
                                                    onChangePage={changePage}
                                                    onChangeRowsPerPage={changeRowsPerPage}
                                                />
                                                </Grid>
                                            </Grid>
                                        </td>
                                    </tr>

                                </TableFooter>

                            </Table>
                        </div>
                    </Grid>
                </Grid>
            </Grid>

        </React.Fragment>
    );

}

const styles = theme => ({
    button_mini: {
        width: 30,
        height: 30,
        padding: 0
    },
    selectFilter: {
        marginTop: 5
    },
    container: {
        margin: -16
    },
    widthAction: {
        minWidth: 180
    },
    widthDate: {
        minWidth: 150
    },
    switchIcon: {
        height: 10,
        width: 10,
        color: "#ffffff"
    },
    fab: {
        marginTop: -30
    },
    tableWrapper: {
        
    },
    table: {
        border: "solid 1px RGB(204, 204, 204)",
        borderRadius: 5,
        display: "inline-block",
        width: "-webkit-fill-available",
        overflowX: "auto"
    }
});


const mapStateToProps = state => {
    return {
        user: state.user.user
    };
};

const mapDispatchToProps = dispatch => {
    return {
        setAspekForAssessment: aspek_id => dispatch(setAspekForAssessment(aspek_id)),

        setAspekEdit: aspek => dispatch(setAspekEdit(aspek)),
        unsetAspekEdit: () => dispatch(unsetAspekEdit()),
    };
  }

const PaAspek = connect(mapStateToProps,mapDispatchToProps)(PaAspekComponent);

export default withRouter(withStyles(styles)(PaAspek));
